import { useState } from "react";
import { Link } from "react-router";
import {
  analyticsConfigured,
  denyConsent,
  getStoredConsent,
  grantConsent,
} from "../../lib/analytics";
import { Button } from "../ui/Button";

/**
 * Cookie/consent banner gating Google Analytics. Only shown when a GA id is
 * configured and the visitor hasn't decided yet. No analytics loads before
 * "Accept". See docs/design-plan.md §8.1.
 */
export function ConsentBanner() {
  const [visible, setVisible] = useState(
    () => analyticsConfigured && getStoredConsent() === null,
  );
  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-[24rem] rounded-xl border border-line bg-surface p-4 shadow-xl sm:inset-x-auto sm:right-4"
    >
      <p className="text-sm text-ink">
        We use Google Analytics to understand how the site is used. It runs only if you accept.
        See our{" "}
        <Link to="/privacy" className="font-medium text-brand-600 underline dark:text-brand-500">
          privacy policy
        </Link>
        .
      </p>
      <div className="mt-3 flex gap-2">
        <Button
          size="md"
          onClick={() => {
            grantConsent();
            setVisible(false);
          }}
        >
          Accept
        </Button>
        <Button
          variant="secondary"
          size="md"
          onClick={() => {
            denyConsent();
            setVisible(false);
          }}
        >
          Decline
        </Button>
      </div>
    </div>
  );
}
